import {
  Component, ElementRef, EventEmitter, Input, NgZone, Output, ViewChild,
  ViewContainerRef
} from '@angular/core';
import { Router } from '@angular/router';
import { LocalizationService, LocalStorageService, ScreenDetectedService } from '@core/services';
import { BtnTypeColor, ListLazyComponents, TypeProduct } from '@enums';
import { BzApteka, BzProduct } from '@interfaces';
import { LazyLoadComponentsService } from 'src/app/lazy-load-components-ui/factories/lazy-load-components.service';
import { select, Store } from '@ngrx/store';
import { AppState } from '@appStates';
import {
  AddOneProductInCartFromListAction,
  AddProductInListAction,
  DeleteOneProductFromListAction,
  DeleteOneProductInCartFromListAction,
  PopupOnePharmcyForActivaMarkerInCartOneGoodAction,
  UpdateCartMarkerAction,
  AddProductInFavoriteAction,
  UnmarkFavoriteAction,
  InListToggleAction,
  UnmarkInListProductFromListAction,
  AddProductToListFromViewedAction,
  AddProductToFavoriteFromViewedAction,
  UnmarkListIconFromListPageAction,
  MarkFavoriteAction,
  UnmarkIsCartIconFromPopUpAction,
  AddOftenProductToListAction,
  AddOftenProductToFavoriteAction,
  UnmarkOftenProductListIconFromListPageAction,
  UnmarkFavoriteProductFromPrivatePageToHomePageAction,
  MarkAsFavoriteFromPrivateViewedPageToHomeTopReserveAction,
  AddOrDeleteProductToList,
  UnmarkInListProductFromListPageAction,
  AddOrDeleteProductToFavoriteAction,
  SetCenterMapAction,
  SetZoomMapAction,
  SelectedCartMarkerAction,
  ToggleFavoriteOftenProductFromViewProducts,
  isGetOtherCityPharmaciesAction,
  IsTargetFromProductCardGetOtherCityPharmaciesAction
} from '@actions';
import { DeleteFromListInfoDrugAction } from '@actions';
import { selectOnePharmaForPopupActiveMarker } from 'src/app/store/selectors/pharmacy.selectors';
import { take } from 'rxjs/operators';
import { selectCurrentCity } from '@selectors';
import { Observable } from 'rxjs';
import { RestUrlService, TypeUrl } from 'src/app/core/services/api.services/settings/rest-url.service';
import { PharmaciesNavigationHelperService } from 'src/app/core/services/helpers/help-service-for-search-page/pharmacies-navigation-helper.service';
import { LocationStorageService } from 'src/app/core/services/storage.services/location-storage-service.service';

@Component({
  selector: 'bz-product',
  templateUrl: './bz-product.component.html',
  styleUrls: ['./bz-product.component.sass']
})
export class BzProductComponent {
  @ViewChild('title', { read: ElementRef, static: false }) public title: ElementRef;
  @ViewChild('dropdownMenu', { read: ViewContainerRef }) public dropdownMenu: ViewContainerRef;

  public colors: typeof BtnTypeColor = BtnTypeColor;
  public _typeProduct: typeof TypeProduct = TypeProduct;
  public ratingActive = '../../../../assets/produt_cool.png';
  // public ratingDeactive = '../../../../assets/produt_noool.png';
  public titleHeight: number;
  public imgPath: string;
  public currentCity: Observable<string> = this.store.select(selectCurrentCity);

  @Output() public onEventsProduct: EventEmitter<{ type: string, idp: BzProduct, data?: MouseEvent }>
    = new EventEmitter();
  @Output() public onClickProduct: EventEmitter<any> = new EventEmitter();
  @Output() public onOpenMenu: EventEmitter<any> = new EventEmitter();
  @Output() public mnvHideDropDowm: EventEmitter<any> = new EventEmitter();

  @Input() public isCart = false;
  @Input() public isList = false;
  @Input() public isOrder = false;
  @Input() public isHomePage = false;
  @Input() public isTopReserve = false;
  @Input() public isViewed = false;
  @Input() public isPrivatePage = false;
  @Input() public isSkeleton = false;
  @Input() public isPharmaciesPage = false;
  @Input() public isSearchPage = false;
  @Input() public isPharmacyPopUp = false;
  @Input() public isCatalogPage = false;

  @Input() public locationORprice: TypeProduct.location | TypeProduct.price | null = this._typeProduct.location;
  @Input() public reviewsORcounts: TypeProduct.reviews | TypeProduct.counts | null = this._typeProduct.reviews;

  @Input() public isBtnToPharmacy = true;
  @Input() public isBtnToMenu = true;

  @Input() public isNameInInfoDetails = false;
  @Input() public isNameInInfoPrices = true;

  @Input() public idApteka: number;
  @Input() public apteka: BzApteka;

  @Input() public BzProduct: BzProduct;
  @Input() public isListCounts = false;

  @Input() public townForNavigateUrl: string;

  public showPopUpQty = false;
  public moveBlock = false;
  public moveTop = false;

  private timeout: NodeJS.Timeout;

  constructor(
    public readonly screen: ScreenDetectedService,
    public readonly locationService: LocationStorageService,
    public readonly localize: LocalizationService,
    private readonly router: Router,
    private readonly lazy: LazyLoadComponentsService,
    private readonly restUrlService: RestUrlService,
    private readonly navigationHelper: PharmaciesNavigationHelperService,
    private readonly ngZone: NgZone,
    private readonly localStorageService: LocalStorageService,
    private readonly store: Store<AppState>
  ) {
    this.imgPath = this.restUrlService.getUrl(TypeUrl.img) + '/';
  }

  public deleteProductFromCart(event?: Event): void {
    if (event) {
      event.preventDefault();
    }
    this.localStorageService.updateOrder(this.idApteka, this.BzProduct.id);

    const pharmcyMap: Map<number, number> = new Map().set(this.idApteka, this.BzProduct.id);
    this.store.dispatch(DeleteOneProductInCartFromListAction({ pharmcyMap }));

    // this.store.dispatch(UpdateCartMarkerAction({markerID: this.idApteka, value: false}));
    // PS: 14.06.2021 - закомитил этот диспатч, т.к. он снимал метку (в коризне) на карте при
    // первом удалении товара из списка товаров в корзине; Маркер должен сниматься тогда, когда
    // удаляется аптека или последний товар из списка товаров в данной аптеке;
  }

  public addProductToCart(): void {
    const pharmcyMap: Map<number, number> = new Map().set(this.apteka.id, this.BzProduct.id);
    if (!this.apteka.isCart) {
      this.localStorageService.addProductToCart(this.apteka, this.BzProduct.id);
    } else if (this.apteka.isCart && !this.BzProduct.isOrder) {
      this.localStorageService.addProductToCart(this.apteka, this.BzProduct.id);
    } else {
      this.localStorageService.updateOrder(this.apteka.id, this.BzProduct.id);
    }

    if (this.BzProduct.isOrder) {
      this.store.dispatch(DeleteOneProductInCartFromListAction({ pharmcyMap }));
    } else {
      this.store.dispatch(AddOneProductInCartFromListAction({ pharmcyMap }));
      this.store.dispatch(SetCenterMapAction({ center: [this.apteka.latitude, this.apteka.longitude] }));
      this.store.dispatch(SetZoomMapAction({ zoom: 19 }));
      this.store.dispatch(SelectedCartMarkerAction({ id: this.apteka.id }));
    }

    const orderedProducts = this.apteka.products.filter(({ isOrder }) => isOrder);
    if (orderedProducts.length === 1 && orderedProducts[0].id === this.BzProduct.id) {
      this.store.dispatch(UpdateCartMarkerAction({ markerID: this.apteka.id, value: false }));
    } else {
      this.store.dispatch(UpdateCartMarkerAction({ markerID: this.apteka.id, value: true }));
    }

    this.store.dispatch(PopupOnePharmcyForActivaMarkerInCartOneGoodAction(
      { produtID: this.BzProduct.id, aptekaID: this.apteka.id }
    ));

    this.store.pipe(
      select(selectOnePharmaForPopupActiveMarker),
      take(1)
    ).subscribe((data: BzApteka) => {
      if (data === null) { return; }
      if (data.products.every(product => product.isOrder === false)) {
        this.store.dispatch(UnmarkIsCartIconFromPopUpAction({ aptekaId: this.apteka.id }));
      }
    });
  }

  public addProductTolist(): void {
    this.localStorageService.addProductTolist(this.BzProduct);
    this.store.dispatch(AddProductInListAction({ product: this.BzProduct.id }));
    this.store.dispatch(InListToggleAction({ id: this.BzProduct.id }));
    // добавить/удалить товар в лист из избранного и менять иконку "в список"
    this.store.dispatch(AddProductToListFromViewedAction({ id: this.BzProduct.id }));
    // добавить/удалить товар в лист из просмотренного и менять иконку "в список"
    this.toList(this.BzProduct, this.BzProduct.id);
    if (this.isHomePage) {
      this.store.dispatch(AddOftenProductToListAction({ product: this.BzProduct }));
    }
    if (this.isTopReserve) {
      this.store.dispatch(AddOrDeleteProductToList({ id: this.BzProduct.id }));
    }
    if (this.isPrivatePage) {
      this.store.dispatch(AddOrDeleteProductToList({ id: this.BzProduct.id }));
    }
  }

  public deleteProductFromList(event?: Event): void {
    if (event) {
      event.preventDefault();
    }
    this.localStorageService.deleteProductFromList(this.BzProduct);
    this.store.dispatch(DeleteOneProductFromListAction({ product: this.BzProduct.id }));
    this.store.dispatch(DeleteFromListInfoDrugAction());
    this.store.dispatch(UnmarkInListProductFromListAction({ id: this.BzProduct.id }));
    // изменить иконку "в списке" на товаре в избранном при удалении товара из листа
    this.store.dispatch(UnmarkListIconFromListPageAction({ id: this.BzProduct.id }));
    // изменить иконку "в списке" на товаре в просмотренном при удалении товара из листа
    this.toList(this.BzProduct, this.BzProduct.id);
    if (this.isList) {
      this.store.dispatch(UnmarkOftenProductListIconFromListPageAction({ product: this.BzProduct }));
      // изменить иконку "в списке" на главной (часто заказываемые) при удалении товара из листа
      this.store.dispatch(UnmarkInListProductFromListPageAction({ id: this.BzProduct.id }));
    }
  }

  // <-- Blisters LIST logic -->

  public incrementCountPackagesInList(): void {
    this.localStorageService.incrementNumberOfPackagesInList(this.BzProduct);
  }

  public incrementCountBlistersInList(): void {
    this.localStorageService.incrementNumberOfBlistersInList(this.BzProduct);
  }

  public decrementCountPackagesInList(): void {
    this.localStorageService.decrementNumberOfPackagesInList(this.BzProduct);
  }

  public decrementCountBlistersInList(): void {
    this.localStorageService.decrementNumberOfBlistersInList(this.BzProduct);
  }

  // <-- Blisters CART logic -->

  public incrementCountPackagesInCart(count: number): void {
    this.checkPopUpInnnerHeight();
    if (count >= this.BzProduct.balancePackage) {
      this.incrementPakcagesInCartHelper();
      return;
    }
    if ((count + 1) >= this.BzProduct.balancePackage && this.BzProduct.blisterNum > this.BzProduct.balanceBlister) {
      this.incrementPakcagesInCartHelper();
      return;
    }
    this.localStorageService.incrementNumberOfPackagesInCart(this.apteka, this.BzProduct);
  }

  public incrementCountBlistersInCart(): void {
    this.checkPopUpInnnerHeight();
    if (this.BzProduct.packageNum === this.BzProduct.balancePackage && this.BzProduct.blisterNum
      === this.BzProduct.balanceBlister) {
      this.titleHeight = this.title.nativeElement.offsetHeight;
      this.moveBlock = true;
      this.showPopUpQty = true;
      if (this.timeout) { clearTimeout(this.timeout); }
      this.timeout = setTimeout(() => this.close(), 3000);
      return;
    }
    this.localStorageService.incrementNumberOfBlistersInCart(this.apteka, this.BzProduct);
  }

  public close(): void {
    this.showPopUpQty = false;
    this.moveTop = false;
    clearTimeout(this.timeout);
  }

  public decrementCountPackagesInCart(count: number): void {
    if (!this.apteka.isPartialSale && count === 1) { return; }
    if (this.BzProduct.packageContentNum === 1 && count === 1) { return; }
    if (this.BzProduct.orderedContentNum === 1 && count === 0) { return; }
    this.localStorageService.decrementNumberOfPackagesInCart(this.apteka, this.BzProduct);
    if (count > 0) {
      count--;
    }
  }

  public decrementCountBlistersInCart(): void {
    this.localStorageService.decrementNumberOfBlistersInCart(this.apteka, this.BzProduct);
  }

  public toPharmcy(event: MouseEvent, product: BzProduct): void {
    this.onEventsProduct.emit({ type: 'toPharmcy', idp: product, data: event });
  }

  public getRouterLinkToPharmcies(): string {
    return this.localize.getRouterLinkApp('pharmacies');
  }

  public onToOrder(event, id): void {
    this.onEventsProduct.emit({ type: 'onToOrder', idp: id, data: event });
  }

  public toFavorite(event, id): void {
    this.onEventsProduct.emit({ type: 'toFavorite', idp: id, data: event });
  }

  public toList(event, id): void {
    this.onEventsProduct.emit({ type: 'toList', idp: id, data: event });
  }

  public redirectToProductInfo(id: number, url: string, nav: boolean = true): void {
    if (nav) {
      this.ngZone.run(() => {
        this.router.navigate(this.localize.getReturnParamsLang(['info-drug', url, id.toString()]));
      });
    }
    this.onClickProduct.next(null);
  }

  public redirectToPharmcy(product: BzProduct): void {
    this.navigationHelper.emittNavigation();
    this.router.navigate(this.localize.getReturnParamsLang(['pharmacies', product.url, this.locationService.townEn]));
  }

  public clearContainer(other: boolean = false): void {
    this.store.dispatch(isGetOtherCityPharmaciesAction({ other }));
    this.store.dispatch(IsTargetFromProductCardGetOtherCityPharmaciesAction({ other }));
    this.onClickProduct.next(null);
  }

  public openMenuPreparat(product: BzProduct, data: number[]): void {

    this.mnvHideDropDowm.emit();
    this.onOpenMenu.next(null);

    if (!this.dropdownMenu.length) {
      this.lazy.addCoreLazyComponent(
        this.dropdownMenu,
        ListLazyComponents.dropMenuProduct).then(ref => {
          ref.instance.data = { product, data };
        });
    } else {
      this.lazy.clearContainer(this.dropdownMenu);
    }
  }

  toOtherPharmacies(): void {
    const town = this.townForNavigateUrl ? this.townForNavigateUrl : this.locationService.townEn;
    this.router.navigate(this.localize.getReturnParamsLang(['pharmacies', this.BzProduct.url, town]));
  }

  // add/delete to favorite method below

  public addProductToFavorite(): void {
    this.localStorageService.addProductToFavorite(this.BzProduct.id);
    if (!this.BzProduct.isFavorite) {
      this.store.dispatch((MarkFavoriteAction({ product: this.BzProduct })));
    } else {
      this.store.dispatch((UnmarkFavoriteAction({ id: this.BzProduct.id })));
    }
    this.store.dispatch(AddProductToFavoriteFromViewedAction({ id: this.BzProduct.id }));
    this.store.dispatch(AddProductInFavoriteAction({ id: this.BzProduct.id }));
    if (this.isHomePage) {
      this.store.dispatch(AddOftenProductToFavoriteAction({ product: this.BzProduct }));
    }

    if (this.isViewed) {
      this.store.dispatch(ToggleFavoriteOftenProductFromViewProducts({ product: this.BzProduct }));
    }

    if (this.isPrivatePage) {
      this.store.dispatch(AddOrDeleteProductToFavoriteAction({ id: this.BzProduct.id }));
      if (!this.BzProduct.isFavorite) {
        this.store.dispatch((MarkAsFavoriteFromPrivateViewedPageToHomeTopReserveAction(
          { product: this.BzProduct })));
      } else {
        this.store.dispatch(UnmarkFavoriteProductFromPrivatePageToHomePageAction({ product: this.BzProduct }));
      }
    }

    if (this.isTopReserve) {
      this.store.dispatch(AddOrDeleteProductToFavoriteAction({ id: this.BzProduct.id }));
    }
  }

  private incrementPakcagesInCartHelper(): void {
    this.titleHeight = this.title.nativeElement.offsetHeight;
    this.moveBlock = false;
    this.showPopUpQty = true;
    if (this.timeout) { clearTimeout(this.timeout); }
    this.timeout = setTimeout(() => this.close(), 3000);
  }

  private checkPopUpInnnerHeight(): void {
    setTimeout(() => {
      const popup: HTMLElement = document.getElementById('popup-qty');
      if (popup == null) { return; }
      const popupHeight: number = popup.offsetHeight;
      if (popupHeight < 60) {
        this.moveTop = true;
      }
    }, 0);
  }

}
